import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { LossAndDamageClaimDetailed } from '@/views/screens/Claims/types';

export interface GetClaimDetailsRequestParams {
  ClaimKey: number;
}

export const getClaimDetailsAPI = (params: GetClaimDetailsRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.LOSS_AND_DAMAGE}/GetClaim`,
  });
};

export type ClaimDetailsResponse = LossAndDamageClaimDetailed;

export const fetchClaimDetails = async (params: GetClaimDetailsRequestParams): Promise<ClaimDetailsResponse> => {
  const response: AxiosResponse<ClaimDetailsResponse> = await getClaimDetailsAPI(params);
  return response.data;
};
